var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import "rxjs/Rx";
import { Actions, Effect, ROOT_EFFECTS_INIT } from "@ngrx/effects";
import { Observable } from "rxjs/Observable";
import { NotificationsService } from "angular2-notifications";
import { AuthenticationService } from "./authentication.service";
import * as AuthActions from "./auth.actions";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { LoadUserAction } from "@core/store/user/user.actions";
import { WindowRefService } from "@core/services/window.service";
import { catchError, flatMap } from "rxjs/operators";
/**
 * Auth Effects
 */
var AuthEffects = /** @class */ (function () {
    function AuthEffects(actions$, authService, notificationService, translate, router, winRef) {
        var _this = this;
        this.actions$ = actions$;
        this.authService = authService;
        this.notificationService = notificationService;
        this.translate = translate;
        this.router = router;
        this.winRef = winRef;
        this.load_storage = this.actions$
            .ofType(ROOT_EFFECTS_INIT)
            .flatMap(function () { return _this.authService.isAuthenticated(); })
            .flatMap(function (isAuthenticated) {
            if (!isAuthenticated) {
                // try to authenticate with refresh token
                return _this.authService.refreshToken().pipe(flatMap(function () { return _this.authService.isAuthenticated(); }), catchError(function () {
                    // return Observable.throw(err);
                    return Observable.of(false);
                }));
            }
            else {
                return Observable.of(isAuthenticated);
            }
        })
            .switchMap(function (isAuthenticated) {
            return _this.authService
                .loadFromStorage()
                .map(function (user) { return new AuthActions.LoginSuccessAction(user); })
                .catch(function () { return Observable.of(new AuthActions.AuthNoAction()); });
        });
        this.login$ = this.actions$
            .ofType(AuthActions.ActionTypes.LOGIN)
            .map(function (action) { return action.payload; })
            .switchMap(function (authData) {
            return _this.authService
                .login(authData.email, authData.password)
                .map(function (user) { return new AuthActions.LoginSuccessAction(user); })
                .catch(function (error) {
                return Observable.of(new AuthActions.LoginFailAction(error));
            });
        });
        this.login_success$ = this.actions$
            .ofType(AuthActions.ActionTypes.LOGIN_SUCCESS)
            .map(function (action) { return action.payload; })
            .do(function (user) {
            // redirect to dashboard
            // this.router.navigate(this.authService.getInterruptedUrl() ? [this.authService.getInterruptedUrl()] : ['dashboard']);
            // push user id to google analytics
            _this.nativeWindow.dataLayer.push({
                userID: user.user_id,
            });
            setTimeout(function () {
                _this.translate.use(user.lang);
            }, 100);
        })
            .map(function () {
            return new LoadUserAction();
        });
        this.login_fail$ = this.actions$
            .ofType(AuthActions.ActionTypes.LOGIN_FAIL)
            .map(function (action) { return action.payload; })
            .switchMap(function (error) {
            return Observable.of(_this.notificationService.error(_this.translate.instant("login.notifications.login_fail.title"), _this.translate.instant("login.notifications.login_fail.text")));
        });
        this.logout$ = this.actions$
            .ofType(AuthActions.ActionTypes.LOGOUT)
            .do(function () {
            _this.authService.logout();
            _this.router.navigate(["login"]);
        });
        this.register$ = this.actions$
            .ofType(AuthActions.ActionTypes.REGISTER)
            .map(function (action) { return action.payload; })
            .switchMap(function (registerData) {
            return _this.authService
                .register(registerData)
                .map(function (user) { return new AuthActions.RegisterSuccessAction(user); })
                .catch(function (error) {
                return Observable.of(new AuthActions.RegisterFailAction(error));
            });
        });
        this.register_success$ = this.actions$
            .ofType(AuthActions.ActionTypes.REGISTER_SUCCESS)
            .map(function (action) { return action.payload; })
            .do(function () {
            _this.router.navigate(["signup/check-email"]);
        })
            .switchMap(function () {
            return Observable.of(_this.notificationService.success(_this.translate.instant("login.notifications.register_success.title"), _this.translate.instant("login.notifications.register_success.text")));
        });
        this.register_fail$ = this.actions$
            .ofType(AuthActions.ActionTypes.REGISTER_FAIL)
            .map(function (action) { return action.payload; })
            .switchMap(function (result) {
            return Observable.of(_this.notificationService.error(_this.translate.instant("login.notifications.register_fail.title"), _this.translate.instant(_this.getRegisterErrorMessage(result))));
        });
        this.reset_password$ = this.actions$
            .ofType(AuthActions.ActionTypes.RESET_PASSWORD)
            .map(function (action) { return action.payload; })
            .switchMap(function (resetPasswordData) {
            return _this.authService
                .recoverPassword(resetPasswordData.email)
                .map(function (token) { return new AuthActions.ResetPasswordSuccessAction(token); })
                .catch(function (error) {
                return Observable.of(new AuthActions.ResetPasswordFailAction(error));
            });
        });
        this.reset_password_success$ = this.actions$
            .ofType(AuthActions.ActionTypes.RESET_PASSWORD_SUCCESS)
            .map(function (action) { return action.payload; })
            .switchMap(function (data) {
            return Observable.of(_this.notificationService.success(_this.translate.instant("reset_password.notifications.reset_success.title"), _this.translate.instant("reset_password.notifications.reset_success.text")));
        });
        this.reset_password_fail$ = this.actions$
            .ofType(AuthActions.ActionTypes.RESET_PASSWORD_FAIL)
            .map(function (action) { return action.payload; })
            .switchMap(function (res) {
            return Observable.of(_this.notificationService.error(_this.translate.instant("reset_password.notifications.reset_fail.title"), _this.translate.instant("reset_password.notifications.reset_fail.text")));
        });
        this.recover_password$ = this.actions$
            .ofType(AuthActions.ActionTypes.RECOVER_PASSWORD)
            .map(function (action) { return action.payload; })
            .switchMap(function (recoverPasswordData) {
            return _this.authService
                .resetPassword(recoverPasswordData.token, recoverPasswordData.password)
                .map(function (token) { return new AuthActions.RecoverPasswordSuccessAction(); })
                .catch(function (error) {
                return Observable.of(new AuthActions.RecoverPasswordFailAction(error));
            });
        });
        this.recover_password_success$ = this.actions$
            .ofType(AuthActions.ActionTypes.RECOVER_PASSWORD_SUCCESS)
            .map(function (action) { return action.payload; })
            .switchMap(function (data) {
            return Observable.of(_this.notificationService.success(_this.translate.instant("recover_password.notifications.recover_success.title"), _this.translate.instant("recover_password.notifications.recover_success.text")));
        })
            .do(function () {
            _this.router.navigate(["login"]);
        });
        this.recover_password_fail$ = this.actions$
            .ofType(AuthActions.ActionTypes.RECOVER_PASSWORD_FAIL)
            .map(function (action) { return action.payload; })
            .switchMap(function (error) {
            return Observable.of(_this.notificationService.error(_this.translate.instant("recover_password.notifications.recover_fail.title"), _this.translate.instant(error.error.message)));
        });
        this.nativeWindow = winRef.getNativeWindow();
    }
    AuthEffects.prototype.getRegisterErrorMessage = function (result) {
        // TODO: this should be improved, we are not covering all the errors
        if (result.status === 400) {
            switch (result.error.violations.email[0].type) {
                case "EMAIL_NOT_UNIQUE":
                    return "login.notifications.register_fail.error.email_not_unique";
            }
        }
        return "notifications.unknown_error";
    };
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "load_storage", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "login$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "login_success$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "login_fail$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "logout$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "register$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "register_success$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "register_fail$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "reset_password$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "reset_password_success$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "reset_password_fail$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "recover_password$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "recover_password_success$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffects.prototype, "recover_password_fail$", void 0);
    return AuthEffects;
}());
export { AuthEffects };



// WEBPACK FOOTER //
// /app/src/app/core/store/auth/auth.effects.ts.pre-build-optimizer.js